<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import g2World from './components/g2world.vue'

export default {
  name: 'app',
  components: {
    g2World
  }
}
</script>

<style>
 #app{
  
  background-size: 100%;
  height: 100%;
  color: #ffffff;
} 

html body{
  margin: 0 0;
  /* width: 2880px; */
  /* height: 1080px; */
}
</style>
